module.exports = __webpack_public_path__ + "img/error.041f7940.svg";